import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { benefitsTranslations } from '../data/translations/benefitsTranslations';

export default function Benefits() {
  const { language } = useLanguage();
  const t = benefitsTranslations[language].benefits;

  return (
    <div className="bg-background text-on-surface font-body">
      <section className="py-24 px-8">
        <div className="max-w-7xl mx-auto">

          {/* Header */}
          <div className="mb-16">
            <span className="text-[10px] font-black uppercase tracking-[0.25em] text-secondary mb-4 block">
              {t.sectionLabel}
            </span>
            <h2 className="font-headline text-4xl lg:text-5xl font-extrabold text-primary leading-tight mb-6">
              {t.title}{' '}
              <span className="text-secondary">{t.titleHighlight}</span>
            </h2>
            <p className="text-on-surface opacity-60 text-base leading-relaxed max-w-2xl">
              {t.description}
            </p>
          </div>

          {/* Benefit Cards — one per specialty */}
          <div className="flex flex-col gap-4">
            {t.items.map((item, i) => (
              <div
                key={i}
                className="group bg-surface border border-border rounded-2xl px-8 py-7 flex flex-col md:flex-row md:items-center gap-8 hover:border-secondary/40 hover:shadow-lg hover:shadow-secondary/5 transition-all duration-300"
              >
                {/* Left — category label */}
                <div className="md:w-52 flex-shrink-0 flex items-center gap-3">
                  <span className="material-symbols-outlined text-secondary text-2xl">{item.icon}</span>
                  <span className="font-headline font-extrabold text-base text-primary uppercase tracking-wide leading-tight">
                    {item.category}
                  </span>
                </div>

                {/* Divider */}
                <div className="hidden md:block w-px h-12 bg-border flex-shrink-0" />

                {/* Right — stats row */}
                <div className="flex flex-wrap gap-x-10 gap-y-5">
                  {item.stats.map((stat, j) => (
                    <div key={j} className="flex flex-col">
                      <span className="font-headline text-2xl font-black text-primary leading-none mb-1 group-hover:text-secondary transition-colors duration-300">
                        {stat.value}
                      </span>
                      <span className="text-[11px] text-on-surface opacity-50 leading-snug max-w-[180px]">
                        {stat.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </div>
  );
}
